import { useConditionActions } from '@retail/calculus/context';
import { EditSalesPriceDialog, EditSalesPriceSchema } from '@retail/my-assortment/components';
import { AssortmentPrices } from '@retail/my-assortment/types';
import { getISO_8601Date } from '@retail/utils';
import { useCallback } from 'react';

interface Props {
  item: AssortmentPrices;
  includeVat: boolean;
  onClose: () => void;
}

export function EditSalesPriceDialogContainer({ item, includeVat, onClose }: Props) {
  const { createMultipleConditions, isLoadingPostChanges } = useConditionActions();

  const handleSubmit = useCallback(
    ({ salesPrice, fromDate }: EditSalesPriceSchema) =>
      createMultipleConditions([
        {
          content: {
            markupTargetPrice: {
              targetPrice: salesPrice,
              incMva: includeVat,
              unit: item.primaryUnit,
            },
          },
          binding: { mgSupplierItem: { supplierItemId: item.mgSupplierItemId } },
          validFrom: getISO_8601Date(fromDate),
        },
      ])
        .then(onClose)
        // Errors are already reported with a toast by useConditionActions
        .catch(() => undefined),
    [createMultipleConditions, includeVat, item, onClose]
  );

  return (
    <EditSalesPriceDialog
      item={item}
      includeVat={includeVat}
      isSaving={isLoadingPostChanges}
      onSubmit={handleSubmit}
      onClose={onClose}
    />
  );
}
